import PreviewQualificationQuestions from './PreviewQualificationQuestions.component';

export default PreviewQualificationQuestions;
